import type React from "react";
import {
  ButtonGroup as ShadcnButtonGroup,
  ButtonGroupSeparator as ShadcnButtonGroupSeparator,
  ButtonGroupText as ShadcnButtonGroupText,
} from "src/shadcn/components/button-group";

const ButtonGroup = (props: React.ComponentProps<typeof ShadcnButtonGroup>) => (
  <ShadcnButtonGroup {...props} />
);

const ButtonGroupSeparator = (
  props: React.ComponentProps<typeof ShadcnButtonGroupSeparator>
) => <ShadcnButtonGroupSeparator {...props} />;

const ButtonGroupText = (
  props: React.ComponentProps<typeof ShadcnButtonGroupText>
) => <ShadcnButtonGroupText {...props} />;

export { ButtonGroup, ButtonGroupSeparator, ButtonGroupText };
export { buttonGroupVariants } from "src/shadcn/components/button-group";
